import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirestore, doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../AuthContext';
import { FiCheckCircle, FiAlertTriangle, FiCreditCard } from 'react-icons/fi';
import './EditBusiness.css';

const ACCOUNT_TYPES = ['Cheque/Current', 'Savings', 'Business'];

export default function EditBanking() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const db = getFirestore();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [banking, setBanking] = useState({
    accountHolder: '', bankName: '', accountNumber: '', accountType: '', branchCode: '',
  });

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'users', currentUser.uid));
        if (snap.exists() && snap.data().banking) {
          setBanking(snap.data().banking);
        }
      } catch (err) {
        console.error('Error loading banking details:', err);
        setError(`Couldn't load your banking details: ${err.code || err.message}`);
      } finally {
        setLoading(false);
      }
    };
    if (currentUser) load();
  }, [currentUser, db]);

  const handleSave = async () => {
    if (!banking.accountHolder || !banking.bankName || !banking.accountNumber || !banking.accountType) {
      setError('Please complete all required fields.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await setDoc(doc(db, 'users', currentUser.uid), {
        banking: { ...banking },
        updatedAt: serverTimestamp(),
      }, { merge: true });
      navigate('/dashboard');
    } catch (err) {
      console.error('Error saving banking details:', err);
      setError(`Couldn't save changes: ${err.code || err.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="edit-business-page">Loading...</div>;

  return (
    <div className="edit-business-page">
      <div className="edit-business-container narrow">
        <h1 className="edit-business-title"><FiCreditCard /> Payout Details</h1>

        {error && <div className="form-error"><FiAlertTriangle /> {error}</div>}

        <div className="edit-section">
          <label>Account Holder Name *</label>
          <input value={banking.accountHolder} onChange={e => setBanking(p => ({ ...p, accountHolder: e.target.value }))} />

          <label>Bank Name *</label>
          <input value={banking.bankName} onChange={e => setBanking(p => ({ ...p, bankName: e.target.value }))} />

          <label>Account Number *</label>
          <input value={banking.accountNumber} onChange={e => setBanking(p => ({ ...p, accountNumber: e.target.value }))} />

          <label>Branch Code</label>
          <input value={banking.branchCode} onChange={e => setBanking(p => ({ ...p, branchCode: e.target.value }))} />

          <label>Account Type *</label>
          <select value={banking.accountType} onChange={e => setBanking(p => ({ ...p, accountType: e.target.value }))}>
            <option value="">Select account type</option>
            {ACCOUNT_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
        </div>

        <div className="step-actions">
          <button className="btn-secondary" onClick={() => navigate('/dashboard')} disabled={submitting}>Cancel</button>
          <button className="btn-primary" onClick={handleSave} disabled={submitting}>
            {submitting ? 'Saving...' : (<><FiCheckCircle /> Save</>)}
          </button>
        </div>
      </div>
    </div>
  );
}